import {InventoryReason} from 'app/blocks/model/inventory-reason.model';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Resource} from 'app/constants/resource';
import {IInventoryReason} from 'app/blocks/model/inventory-reason.model';
import EntityCrudService from 'app/blocks/service/api/entity-service';

@Injectable({
    providedIn: 'root'
})
export class InventoryReasonService extends EntityCrudService<IInventoryReason> {
    constructor(http: HttpClient) {
        super(http, Resource.INVENTORY_REASONS, (obj?) => new InventoryReason(obj));
    }
}
